import {TitleSelectionValue} from '../component/title-selection-component.domain';
import {RoleTypes, SignerRoleTypes} from '../application-service.domain';

export type ContactValue = {
  isManual: boolean | null,
  title: TitleSelectionValue | null,
  firstName: string,
  lastName: string,
  mobileNumber: string,
  telephone: string,
  email: string,
  areaCode: string,
};
export type SelectContactValue = ContactValue | null;

// One entry in the final summary's Contacts section: every individual from the Individual Details
// step, with the one nominated as primary flagged so it can be marked. Roles are carried so the
// summary can say why each person is on the application, which it used to convey by listing them
// again under a per-role heading.
export type SummaryContactValue = ContactValue & {
  isPrimaryContact: boolean,
  role: RoleTypes,
  signerRole: SignerRoleTypes,
};

// One entry in the final summary's Entities section: a corporate party of the application. These
// have no individual to list under Contacts, so they are gathered here with the role that put them
// on the application.
export type SummaryEntityValue = {
  role: string,
  name: string,
  organisationType: string,
  abn: string,
  acn: string,
};

